import { createFileRoute, redirect } from '@tanstack/react-router'

// Redirect old email links (/api/invitations/:token) to the new frontend page
export const Route = createFileRoute('/api/invitations/$token')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/invitations/$token', params: { token: params.token } })
  },
  component: () => null,
})
